module.exports = __webpack_public_path__ + "img/Nikki-Max-Quality.8f467f4d.jpg";